import * as React from 'react';
import { PureIconContainer } from './utils/IconContainer';
var EyeShow = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(PureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_EyeShow_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 3,
    width: 16,
    height: 10
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5 8a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Zm-1 0a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 3C3.429 3 0 6.889 0 8c0 1.111 3.429 5 8 5s8-3.889 8-5c0-1.111-3.429-5-8-5ZM1.057 8.1a1.235 1.235 0 0 1-.043-.1c.009-.024.022-.056.043-.1.067-.138.18-.325.349-.548A8.227 8.227 0 0 1 2.9 5.872C4.208 4.856 5.998 4 8 4s3.792.855 5.1 1.873a8.223 8.223 0 0 1 1.495 1.48c.168.222.281.409.348.548.02.043.034.075.043.099a1.24 1.24 0 0 1-.043.1c-.067.138-.18.325-.348.548a8.223 8.223 0 0 1-1.495 1.48C11.792 11.144 10.002 12 8 12s-3.792-.855-5.1-1.873a8.227 8.227 0 0 1-1.494-1.48 3.435 3.435 0 0 1-.35-.548Z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_EyeShow_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  }))));
});
export default EyeShow;